




















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import { RepositoryFactory } from '@/api/RepositoryFactory';
import { log } from 'console';
import { ActuatorType } from '@/models/actuatorType';
import { MaintenanceListElement } from '@/models/maintenanceListElement';


const ActuatorTypeStore = namespace('actuatorType');

@Component({
  components: {
    JunusComponentView: () => import('./newActuator/Junus.component.vue'),
  }
})
export default class ActuatorsView extends Vue {

  @ActuatorTypeStore.Getter('actuatorTypes')
  public actuatorTypes!: ActuatorType[];

  @ActuatorTypeStore.Action('loadAllActuatorTypes')
  public loadAllActuatorTypes!: () => Promise<ActuatorType[]>;

  private actuatorTypeRepository = RepositoryFactory.get('actuatorType');
  private maintenanceListElementRepository = RepositoryFactory.get('maintenanceListElement');
  private maintenanceListElementEntryRepository = RepositoryFactory.get('maintenanceListElementEntry');
  private adminRepository = RepositoryFactory.get('admin');
  private machineRepository = RepositoryFactory.get('machine');

  //public actuatorTypes = ['SEHAZ', 'EHAZ', 'SEHAZc', 'GEHAZ', 'GHAZ', 'SAE', 'PAZ', 'GAZ', 'HAZ', 'ZEHAZ', 'MHAZ', 'EHAZ-R', 'GHAZ2', 'SEHAZ-R', 'DEHAZ'];
  // public actuatorTypes: ActuatorType[] = [];

  public selectedActuatorType: ActuatorType | null = null;
  public newActuatorName = '';
  public editingActuatorType: ActuatorType | null = null;
  public createActuatorDialog = false;
  public selectedMaintenanceListElementIndices: number[] = [];
  public snackbar: boolean = false;
  public snackbarText: string = '';
  public snackbarColor: string = 'error';

  // State für den Löschen-Dialog
  public deleteActuatorDialog = false;
  public actuatorToDelete: ActuatorType | null = null;
  public actuatorToDeleteInUse = false;
  // Stationen/Projekte die diesen Antrieb verwenden: { stationId, stationName, customerName, machineCount }
  public actuatorUsedInStations: { stationId: string; stationName: string; customerName: string; machineCount: number }[] = [];
  public checkingActuatorUsage = false;
  public machineCheckFailed = false; // true wenn der Maschinen-Endpunkt nicht erreichbar war
  public deletingActuator = false;
  public selectedMaintenanceListElements: MaintenanceListElement[] = [];

  // Property to store IDs of elements that are already assigned as entries
  public assignedMaintenanceListElementIds: string[] = [];

  public openCreateNewMaintenanceListElementDialog = false;
  public maintenanceListElementName: string = '';
  public selectedMaintenanceListElement: MaintenanceListElement | null = null;
  public isEditing = false;
  public amountOfMaintenanceListElementEntries = 0;

  public allMaintenanceListElements: MaintenanceListElement[] = [];

  public async mounted() {

    try {

      // load all Actuator Types using store action
      await this.loadAllActuatorTypes();
      this.selectedActuatorType = this.actuatorTypes[0] as ActuatorType;

      const maintenanceListElements = await this.maintenanceListElementRepository.getAllItems();

      this.allMaintenanceListElements = maintenanceListElements.data;
    } catch (error) {
      console.error(error);
    }

    this.processMaintenanceListElements();

  }

  /**
   * Processes the defaultMaintenanceListElements array by filtering out invalid items
   * and adding chipId to each valid item
   */
  private processMaintenanceListElements(): void {
    // Only process if we have valid data
    if (this.allMaintenanceListElements && Array.isArray(this.allMaintenanceListElements)) {
      // Filter out any undefined or null items first
      this.allMaintenanceListElements = this.allMaintenanceListElements
        .filter((item: MaintenanceListElement) => item && item.id) // Remove undefined/null items
        .map((item: MaintenanceListElement, index: number) => ({ ...item, chipId: index + 1 }));
    } else {
      console.warn('defaultMaintenanceListElements is not a valid array:', this.allMaintenanceListElements);
      this.allMaintenanceListElements = [];
    }
  }

  /**
   * This function is called when the user selects an element in the Alle Elemente list
   * converts indices to objects and filters out any undefined results
   * @param selectedIndices 
   */
  onMaintenanceListElementSelectionChange(selectedIndices: number[]) {
    // Map array indices to objects with database IDs
    this.selectedMaintenanceListElements = selectedIndices.map(index =>
      this.allMaintenanceListElements[index]
    ).filter(obj => obj); // Remove any undefined results


  }

  public openCreateNewActuatorDialog() {
    this.editingActuatorType = null;
    this.newActuatorName = '';
    this.createActuatorDialog = true;
  }

  public openEditActuatorDialog(actuator: ActuatorType) {
    this.editingActuatorType = actuator;
    this.newActuatorName = actuator.name;
    this.createActuatorDialog = true;
  }

  /** Öffnet den Löschen-Dialog und prüft ob der Antrieb verknüpfte Elemente hat */
  public async openDeleteActuatorDialog(actuator: ActuatorType) {
    this.actuatorToDelete = actuator;
    this.deletingActuator = false;
    this.actuatorToDeleteInUse = false;
    this.actuatorUsedInStations = [];
    this.machineCheckFailed = false;
    this.checkingActuatorUsage = true;
    this.deleteActuatorDialog = true;

    // Verknüpfungen parallel prüfen: ActuatorType-Details + Maschinen mit Station
    const [actuatorResult, machinesResult] = await Promise.allSettled([
      this.actuatorTypeRepository.getActuatorType(String(actuator.id)),
      this.machineRepository.getMachinesByActuatorName(actuator.lowerCaseName || actuator.name.toLowerCase()),
    ]);

    // Prüfen ob der Antrieb Formulare oder Prüflisteneinträge hat
    if (actuatorResult.status === 'fulfilled') {
      const fresh: ActuatorType = new ActuatorType(actuatorResult.value.data);
      // Only check entries – forms are auto-created by the backend and always present
      this.actuatorToDeleteInUse =
        (fresh.maintenanceListElementEntries?.length ?? 0) > 0;
    } else {
      this.actuatorToDeleteInUse = true;
    }

    // Maschinen nach Station gruppieren und als Liste aufbereiten
    if (machinesResult.status === 'rejected') {
      // Endpunkt nicht verfügbar – Löschen sperren und Hinweis anzeigen
      console.error('[ActuatorDelete] Maschinen-Endpunkt nicht erreichbar:', machinesResult.reason);
      this.machineCheckFailed = true;
    } else if (machinesResult.status === 'fulfilled') {
      const machines: any[] = machinesResult.value.data ?? [];
      const stationMap = new Map<string, { stationName: string; customerName: string; machineCount: number }>();

      for (const machine of machines) {
        const station = machine.station;
        if (!station) continue;
        const stationId = station.id ?? station._id ?? String(station);
        const stationName = station.name ?? stationId;
        const customerName =
          typeof station.customer === 'object'
            ? (station.customer?.name ?? '')
            : '';

        if (stationMap.has(stationId)) {
          stationMap.get(stationId)!.machineCount++;
        } else {
          stationMap.set(stationId, { stationName, customerName, machineCount: 1 });
        }
      }

      this.actuatorUsedInStations = Array.from(stationMap.entries()).map(([stationId, data]) => ({
        stationId,
        ...data,
      }));
    }

    this.checkingActuatorUsage = false;
  }

  // Hilfsgetter: Löschen sperren wenn Maschinen-Check fehlschlug oder Verknüpfungen vorhanden
  get isDeleteBlocked(): boolean {
    return this.checkingActuatorUsage ||
      this.actuatorToDeleteInUse ||
      this.actuatorUsedInStations.length > 0 ||
      this.machineCheckFailed;
  }

  /** Führt das tatsächliche Löschen nach Bestätigung durch */
  public async confirmDeleteActuator() {
    if (!this.actuatorToDelete) return;
    this.deletingActuator = true;
    try {
      await this.actuatorTypeRepository.deleteActuatorType(String(this.actuatorToDelete.id));

      // Aus lokaler Liste entfernen
      const idx = this.actuatorTypes.findIndex(a => a.id === this.actuatorToDelete!.id);
      if (idx > -1) this.actuatorTypes.splice(idx, 1);

      // Selektion zurücksetzen falls gelöschter Antrieb ausgewählt war
      if (this.selectedActuatorType?.id === this.actuatorToDelete.id) {
        this.selectedActuatorType = this.actuatorTypes[0] ?? null;
      }

      this.snackbarColor = 'success';
      this.snackbarText = `Antrieb "${this.actuatorToDelete.name}" wurde gelöscht`;
    } catch (error) {
      console.error('Fehler beim Löschen des Antriebs:', error);
      this.snackbarColor = 'error';
      this.snackbarText = 'Fehler beim Löschen des Antriebs';
    }
    this.snackbar = true;
    this.deletingActuator = false;
    this.deleteActuatorDialog = false;
    this.actuatorToDelete = null;
  }

  public closeActuatorDialog() {
    this.createActuatorDialog = false;
    this.editingActuatorType = null;
    this.newActuatorName = '';
  }

  public onActuatorDialogClose(open: boolean) {
    if (!open) this.closeActuatorDialog();
  }

  public async saveActuatorDialog() {
    const name = this.newActuatorName?.trim();
    if (!name) return;

    // Duplicate check – case-insensitive, exclude self when editing
    const isDuplicate = this.actuatorTypes.some(a =>
      a.name.toLowerCase() === name.toLowerCase() &&
      a.id !== this.editingActuatorType?.id
    );
    if (isDuplicate) {
      this.snackbarColor = 'error';
      this.snackbarText = `Ein Antrieb mit dem Namen "${name}" existiert bereits.`;
      this.snackbar = true;
      return;
    }

    if (this.editingActuatorType) {
      try {
        const updated = { ...this.editingActuatorType, name, lowerCaseName: name.toLowerCase() };
        await this.actuatorTypeRepository.updateActuatorType(updated);
        await this.loadAllActuatorTypes();
        const found = this.actuatorTypes.find(a => a.id === this.editingActuatorType!.id);
        if (found) this.selectedActuatorType = found;
        this.snackbarColor = 'success';
        this.snackbarText = 'Antrieb aktualisiert';
        this.snackbar = true;
        this.closeActuatorDialog();
      } catch (error) {
        console.error(error);
        this.snackbarColor = 'error';
        this.snackbarText = 'Fehler beim Aktualisieren des Antriebs';
        this.snackbar = true;
      }
    } else {
      await this.createNewActuatorType();
    }
  }

  public async createNewActuatorType() {
    const name = this.newActuatorName?.trim();
    if (!name) return;
    try {
      const newActuator = { name, lowerCaseName: name.toLowerCase() };
      const actuatorType = await this.actuatorTypeRepository.createActuatorType(newActuator as ActuatorType);

      this.actuatorTypes.push(actuatorType.data);
      this.selectedActuatorType = actuatorType.data;
      this.closeActuatorDialog();
    } catch (error) {
      console.error(error);
    }
  }

  public async createMaintenanceListElement() {
    if (!this.maintenanceListElementName.trim()) return;

    try {
      const newItem = await this.maintenanceListElementRepository.createItem({
        name: this.maintenanceListElementName
      });

      this.allMaintenanceListElements.push(newItem.data);
      // Reprocess the array to ensure proper chipId assignment and consistency
      this.processMaintenanceListElements();
      this.snackbarColor = 'success';
      this.snackbarText = 'Prüflisten Element erfolgreich erstellt';
    } catch (error) {
      console.error(error);
      this.snackbarColor = 'error';
      if ((error as any).status === 409) {
        this.snackbarText = 'Prüflisten Element bereits vorhanden';
      } else {
        this.snackbarText = 'Fehler beim Erstellen des Prüflisten Elements';
      }
    }
    this.snackbar = true;
    this.openCreateNewMaintenanceListElementDialog = false;
    this.maintenanceListElementName = '';
  }

  public createNewMaintenanceListElementDialog() {
    this.isEditing = false;
    this.maintenanceListElementName = '';
    this.selectedMaintenanceListElement = null;
    this.openCreateNewMaintenanceListElementDialog = true;
  }

  public async createMahmut() {
    const newMaintenanceListElement = [
      'Steuerung mit allen Teilen',
      'Lackschaden / Korrosion',
      'Verschmutzung',
      'Beschädigungen',
      'Leckagen',
      'Verkabelung',
      'Verrohrung & Schläuche',
      'Aufbau der Steuerung',
      'Dichtigkeit der Steuerung',
      'Elektrosteuergehäuse'
    ] as const;
    const funktionaleElemente = [
      'Ölstand',
      'Blocktechnikfilter',
      'Ölqualität',
      'N2-Vorfülldruck',
      'Sicherheitsgruppe',
      'Handpumpe',
      'KTI-Kontaktinstrument',
      'Manometer',
      'Sicherheitsventil',
      'Ansaugfilter',
      'Stromversorgung',
      'E-Steuerung-Einstellwerte',
      'E-Steuerung-Funktion',
      'E-Steuerung-Endschalter',
      'E-Steuerung-Positionsmelder',
      'E-Steuerung Initiatoren',
      'Vor Ort Steuerung',
      'Fernsteuerung',
      'Interne Signalmeldungen',
      'Alarme / Rückmeldungen',
      'Mechanische Stellungsanzeigen',
      'Magnetventile (Manuell)',
      'Magnetventile (E-gesteuert)',
      'Speicherladezeit',
      'Motorstromaufnahme',
      'Stellzeit (AUF)'
    ] as const;
    
    for (const element of newMaintenanceListElement) {
      const newMaintenanceListElement = { name: element } as const;

      try {
        const newItem = await this.maintenanceListElementRepository.createItem({
          name: element
        });

        this.allMaintenanceListElements.push(newItem.data);
      } catch (error) {
        this.snackbarColor = 'error';
        if ((error as any).status === 409) {
          this.snackbarText = 'Prüflisten Element bereits vorhanden';
        } else {
          this.snackbarText = 'Fehler beim Erstellen des Prüflisten Elements';
        }
        this.snackbar = true;
        console.error(error);
      }
    }

    for (const element of funktionaleElemente) {
      const newMaintenanceListElement = { name: element } as const;

      try {
        const newItem = await this.maintenanceListElementRepository.createItem({
          name: element
        });

        this.allMaintenanceListElements.push(newItem.data);
      } catch (error) {
        this.snackbarColor = 'error';
        if ((error as any).status === 409) {
          this.snackbarText = 'Prüflisten Element bereits vorhanden';
        } else {
          this.snackbarText = 'Fehler beim Erstellen des Prüflisten Elements';
        }
        this.snackbar = true;
        console.error(error);
      }
    }
    this.snackbarColor = 'success';
    this.snackbarText = 'Prüflisten Elemente erfolgreich erstellt';
    this.snackbar = true;
  }



  public async deleteMaintenanceListElement(item: MaintenanceListElement) {
    try {
      if (item.id) {
        await this.maintenanceListElementRepository.deleteItem(item.id);
        // Remove from local array
        const index = this.allMaintenanceListElements.findIndex(element => element.id === item.id);
        if (index > -1) {
          this.allMaintenanceListElements.splice(index, 1);
        }
        this.snackbarColor = 'success';
        this.snackbarText = 'Element erfolgreich gelöscht';
      }
    } catch (error) {
      console.error('Error deleting maintenance list element:', error);
      this.snackbarColor = 'error';
      this.snackbarText = 'Fehler beim Löschen des Elements';
    }
    this.snackbar = true;
  }

  public async editMaintenanceListElement(item: MaintenanceListElement) {
    // item.description because of the old code

    this.maintenanceListElementName = item.name || '';
    this.selectedMaintenanceListElement = item;
    this.isEditing = true;
    this.openCreateNewMaintenanceListElementDialog = true;
    await this.getCountOfMaintenanceListElement();
  }

  public closeMaintenanceListElementDialog() {
    this.openCreateNewMaintenanceListElementDialog = false;
    this.maintenanceListElementName = '';
    this.selectedMaintenanceListElement = null;
    this.isEditing = false;
  }




  public async getCountOfMaintenanceListElement(): Promise<void> {
    // get MaintenanceListElement in MaintenanceListElementEntry
    if (!this.selectedMaintenanceListElement?.id) {
      this.amountOfMaintenanceListElementEntries = 0;
      return;
    }

    try {
      // get all MaintenanceListElementEntry
      const maintenanceListElementEntry = await this.maintenanceListElementEntryRepository.getCountByMaintenanceListElement(this.selectedMaintenanceListElement.id);
      this.amountOfMaintenanceListElementEntries = maintenanceListElementEntry.data || 0;
    } catch (error) {
      console.error('Error getting count:', error);
      this.amountOfMaintenanceListElementEntries = 0;
    }
  }

  public async saveMaintenanceListElement() {
    if (this.isEditing) {
      await this.updateMaintenanceListElement();
    } else {
      await this.createMaintenanceListElement();
    }
  }

  public async updateMaintenanceListElement() {
    if (!this.maintenanceListElementName.trim() || !this.selectedMaintenanceListElement) return;

    try {
      await this.maintenanceListElementRepository.updateItem(this.selectedMaintenanceListElement.id!, {
        name: this.maintenanceListElementName
      });

      // Update local array
      const index = this.allMaintenanceListElements.findIndex(element => element.id === this.selectedMaintenanceListElement?.id);
      if (index > -1) {
        this.allMaintenanceListElements[index].name = this.maintenanceListElementName;
      }

      this.snackbarColor = 'success';
      this.snackbarText = 'Prüflisten Element erfolgreich aktualisiert';
    } catch (error) {
      console.error(error);
      this.snackbarColor = 'error';
      this.snackbarText = 'Fehler beim Aktualisieren des Prüflisten Elements';
    }
    this.snackbar = true;
    this.closeMaintenanceListElementDialog();
  }

  public async deleteSelectedMaintenanceListElement() {
    if (this.selectedMaintenanceListElement) {
      await this.deleteMaintenanceListElement(this.selectedMaintenanceListElement);
      this.closeMaintenanceListElementDialog();
    }
  }


  public onClickActuator(actuator: ActuatorType) {
    this.selectedActuatorType = actuator;
  }

  /**
   * This function is called when the child component emits the selected items to check the selected items in Alle Elemente
   * @param newItems 
   */
  onSelectMantainanceListElements(selectedMaintenanceListElementIds: string[]) {
    // Store the IDs of elements that are already assigned as entries
    this.assignedMaintenanceListElementIds = selectedMaintenanceListElementIds;

    // Update selectedItems by finding matching IDs and getting their array indices
    this.selectedMaintenanceListElementIndices = this.allMaintenanceListElements
      .map((item: MaintenanceListElement, index: number) => {
        // Für jedes Element in validMaintenanceListElements wird geprüft:
        // - itemId ist die ID des aktuellen Elements als String
        // - hasMatch prüft ob diese ID in selectedMaintenanceListElementIds vorkommt
        // Wenn ein Match gefunden wird, wird der Index zurückgegeben, sonst -1
        const itemId = String(item.id);
        const hasMatch = selectedMaintenanceListElementIds.some((maintenanceListElementId: string) => maintenanceListElementId === itemId);

        return hasMatch ? index : -1;
      })
      .filter((index: number) => index !== -1);

    // Update selectedObjects with the corresponding objects
    this.selectedMaintenanceListElements = this.selectedMaintenanceListElementIndices.map((index: number) => this.allMaintenanceListElements[index]);

  }

  /**
   * This function is used to delete the static tables in DB
   */
  public async atom() {
    try {
      const response = await this.adminRepository.deleteStaticTables();

      console.log('Static tables deleted successfully:', response.data);
      this.snackbarColor = 'success';
      this.snackbarText = 'Statische Tabellen erfolgreich gelöscht';
      this.snackbar = true;
    } catch (error) {
      console.error('Error deleting static tables:', error);
      this.snackbarColor = 'error';
      this.snackbarText = 'Fehler beim Löschen der statischen Tabellen';
      this.snackbar = true;
    }
  }

  private getChipId(item: MaintenanceListElement): string {
    return String((item as any).chipId);
  }

  private isItemSelected(item: MaintenanceListElement): boolean {
    return this.assignedMaintenanceListElementIds.includes(String(item.id));
  }

}

